import React from 'react';

import InlineAlert from 'app/commonComponents/InlineAlert';

import { is } from '../../utils';
import { useAppContext } from '../../hooks';

import Form from '../Form';
import FormField from '../FormField';
import FormFooter from '../FormFooter';
import { AppleButton, GoogleButton } from '../SocialAuthButton';

export const MISSING_USERNAME_MESSAGE = i18n.gettext(
  'Please provide your email address.'
);
export const INVALID_USERNAME_MESSAGE = i18n.gettext(
  'Please provide a valid email address.'
);
export const MISSING_PASSWORD_MESSAGE = i18n.gettext(
  'Please provide your password.'
);

const initialValues = {
  username: '',
  password: '',
};

function validate(values) {
  const errors = {};
  if (is.empty(values.username)) {
    errors.username = MISSING_USERNAME_MESSAGE;
  } else if (!is.email(values.username)) {
    errors.username = INVALID_USERNAME_MESSAGE;
  }
  if (is.empty(values.password)) {
    errors.password = MISSING_PASSWORD_MESSAGE;
  }
  return errors;
}

function SigninForm() {
  const { config } = useAppContext();
  return (
    <Form initialValues={initialValues} validate={validate}>
      <FormField
        id="username"
        name="username"
        type="email"
        label={i18n.gettext('Email')}
        style={{ marginBottom: '2rem' }}
      />
      <FormField
        id="password"
        name="password"
        type="password"
        label={i18n.gettext('Password')}
        style={{ marginBottom: '2rem' }}
        disabled={config.form_errors.password}
        ignoreError={(name, error) =>
          // password server error will be handled explicitly down below
          name === 'password' && error === config.form_errors.password
        }
      />
      {config.form_errors.password ? (
        <InlineAlert type="error" style={{ marginBottom: '1rem' }}>
          <span
            dangerouslySetInnerHTML={{
              __html: i18n.gettext(
                'Your password does not match our updated security policy. Please <a href="/password/reset">reset your password</a>.'
              ),
            }}
          />
        </InlineAlert>
      ) : (
        <div style={{ marginBottom: '1rem' }}>
          <a href="/password/reset">{i18n.gettext('Forgot your password?')}</a>
        </div>
      )}
      <FormFooter submitButtonLabel={i18n.gettext('Sign in')} />
      <div style={{ margin: '3rem 0', textAlign: 'center' }}>
        {i18n.gettext('or sign in with')}
      </div>
      {config.social_auth_error && (
        <div>
          {i18n.gettext(
            'Social authentication is failed, please make sure you do not have duplicated email address.'
          )}
        </div>
      )}
      <GoogleButton targetUrl={config.google_login_url} />
      <AppleButton targetUrl={config.apple_login_url} />
    </Form>
  );
}

export default SigninForm;
